
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { makeWordPressAjaxRequest } from "@/lib/wordpress/ajax";
import { pipe } from "fp-ts/lib/function";
import * as t from "io-ts";
import { fold } from "fp-ts/lib/Either";
import { PostChooserOptions } from "@/types/post-chooser";

export const PostV = t.type({
  id: t.number,
  title: t.string,
  thumbnail: t.union([t.string, t.literal(false)])
});
export type Post = t.TypeOf<typeof PostV>;

const DEFAULT_OPTIONS = {
  multiple: false,
  showThumbnails: false,
  postType: "post"
};

@Component
export default class PostChooserInput extends Vue {
  @Prop()
  value!: number[];

  @Prop({
    default() {
      return DEFAULT_OPTIONS;
    }
  })
  options!: PostChooserOptions;

  posts: Post[] = [];
  loading = false;
  search = "";

  get postType() {
    return this.options.postType ?? "post";
  }

  @Watch("search")
  async onSearch() {
    this.posts = await this.getPosts(this.search, this.postType);
  }

  async getPosts(search: string, postType: string) {
    this.loading = true;

    const posts = pipe(
      await makeWordPressAjaxRequest({
        action: "breakdance_get_posts",
        decoder: t.array(PostV),
        dataToPost: { search, postType },
        resultKey: "data"
      }),
      fold(
        () => [],
        posts => posts
      )
    );

    this.loading = false;
    return posts;
  }

  clear() {
    this.$emit("input", undefined);
  }

  edit(newVal: number[]) {
    this.search = "";
    this.$emit("input", newVal);
  }
}
